import { useAssetsStore } from 'store'

export const ControlledAmount = defineComponent({
  name: 'ControlledAmount',

  setup(_, { slots }) {
    const assetsStore = useAssetsStore()
    return () => {
      if (assetsStore.isShowAssets) {
        return <span>{slots.default?.()}</span>
      }
      return <span>*****</span>
    }
  },
})
